import { z } from "zod";

import { parseMultiplier } from "./format-multiplier";

const blank = (v: string | undefined): boolean => v === undefined || v.trim() === "";

const optionalMultiplier = z
  .string()
  .trim()
  .optional()
  .refine((v) => blank(v) || parseMultiplier(v as string).ok, {
    message: "bulk.edit.invalid_multiplier",
  });

const optionalInteger = z
  .string()
  .trim()
  .optional()
  .refine((v) => blank(v) || /^\d+$/.test(v as string), {
    message: "bulk.edit.invalid_integer",
  });

export const bulkEditSchema = z
  .object({
    multiplier: optionalMultiplier,
    fake: optionalInteger,
    lock: optionalInteger,
  })
  .refine((d) => !blank(d.multiplier) || !blank(d.fake) || !blank(d.lock), {
    message: "bulk.edit.at_least_one",
    path: ["multiplier"],
  });

export type BulkEditFormValues = z.infer<typeof bulkEditSchema>;

/** Convert validated form strings to the PATCH body shape, omitting blank fields. */
export function toBulkPatchBody(v: BulkEditFormValues): {
  multiplier?: string;
  fake?: number;
  lock?: number;
} {
  const body: { multiplier?: string; fake?: number; lock?: number } = {};
  if (!blank(v.multiplier)) {
    const parsed = parseMultiplier(v.multiplier as string);
    if (parsed.ok) body.multiplier = parsed.value;
  }
  if (!blank(v.fake)) body.fake = Number(v.fake);
  if (!blank(v.lock)) body.lock = Number(v.lock);
  return body;
}
